/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

function isShipmentDetailPath(pathname: string) {
  return /^\/shipments\/[a-zA-Z0-9]+$/.test(pathname);
}

function getCompanyIdQueryParam(url: URL) {
  const params = new URLSearchParams(url.search);
  return params.get('companyId');
}

bootstrapApplication(AppComponent, appConfig)
  .then(() => {
    const url = new URL(window.location.href);
    const redirectPathname = url.pathname;
    if (isShipmentDetailPath(redirectPathname)) {
      const companyId = getCompanyIdQueryParam(url);
      if (companyId) {
        localStorage.setItem('sharedShipmentInfo', JSON.stringify({ companyId, redirectPathname }))
      }
    }
  })
  .catch((err) => console.error(err));
